import styled from '@emotion/styled';
import MuiMenuList from '@material-ui/core/MenuList';
import ButtonBase from '@material-ui/core/ButtonBase';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import COLORS from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const styles = {
  paper: {
    'box-shadow': `0px 0px 8px 0px ${COLORS.shadow3}`,
    'margin-top': spacing.xxSmall,
  },
};

export const MenuItem = styled.div`
  padding: ${spacing.xSmall} ${spacing.medium};
  line-height: 24px;
  background-color: ${COLORS.white};
  white-space: normal;

  :hover {
    background-color: ${COLORS.grey4};
  }

  cursor: pointer;
`;

export const MenuList = styled(MuiMenuList)`
  outline: none;
  padding: 0;
`;

export const Button = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'hasLightText',
})`
  justify-content: space-between;
  padding: ${spacing.xxSmall} 0 ${spacing.xxSmall} 6px;
  background: transparent;
  border-radius: 4px;
  font-weight: ${typography.fontWeightSemiBold};
  font-size: 14px;
  line-height: 20px;
  display: flex;
  color: ${({ hasLightText }) =>
    hasLightText ? COLORS.shadow5 : COLORS.shadow6};
`;

export const ExpandIcon = styled(ArrowDropDownIcon)`
  color: ${COLORS.shadow5};
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);

  ${({ open }) =>
    open &&
    `
    transform: rotate(180deg);
  `};
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: ${typography.fontFamily};
`;
